import React, { useEffect, useState, useRef } from "react";
import { ListGroup, Container, Collapse } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { setMsalValues } from "../common/msalService";
import {
  FaChevronDown,
  FaChevronUp,
  FaUserFriends,
  FaUserPlus,
  FaUser,
  FaLaptop,
  // FaHome,
  FaAws,
  FaCloud,
} from "react-icons/fa";
import { SiGooglecloud } from "react-icons/si";
import { getUserData } from "../features/userSlice";
import { useSelector } from "react-redux";

function SideBar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { instance, inProgress, accounts } = useMsal();
  const hasDispatched = useRef(false);
  const { loginUser, isLoaded, error } = useSelector((state) => state.user);
  const [openManageResource, setOpenManageResource] = useState(true);
  const [openManageSchedule, setopenManageSchedule] = useState(false);

  useEffect(() => {
    setMsalValues(instance, inProgress);
    const data = {
      user_name: instance.getActiveAccount()?.name,
    };

    if (hasDispatched.current) return;
    if (!instance || !accounts || inProgress !== "none") return;

    hasDispatched.current = true;
    dispatch(getUserData(data));
  }, [instance, accounts, inProgress, dispatch]);

  return (
    <Container>
      <ListGroup className="nav-item">
        {/* Home */}
        {/* <LinkContainer to="/">
          <ListGroup.Item action className="list-group-item-info nav-link d-flex align-items-center">
            <FaHome style={{ marginRight: '10px', fontSize: '20px' }} />
            Home
          </ListGroup.Item>
        </LinkContainer> */}

        {/* Manage Resource */}
        <>
          <ListGroup.Item
            action
            className="list-group-item-info nav-link d-flex align-items-center"
            onClick={() => setOpenManageResource(!openManageResource)}
            aria-controls="manage-resource-collapse"
            aria-expanded={openManageResource}
          >
            <FaLaptop style={{ marginRight: "10px", fontSize: "20px" }} />
            Manage Resource
            {openManageResource ? (
              <FaChevronUp style={{ marginLeft: "auto" }} />
            ) : (
              <FaChevronDown style={{ marginLeft: "auto" }} />
            )}
          </ListGroup.Item>

          <Collapse in={openManageResource}>
            <div id="manage-resource-collapse">
              {loginUser.perms?.AWS?.length > 0 && (
                <ListGroup.Item
                  action
                  className="list-group-item-secondary nav-link d-flex align-items-center"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (location.pathname !== "/user/AWSAccounts") {
                      window.location.href = "/user/AWSAccounts";
                    }
                  }}
                >
                  <FaAws
                    style={{
                      fontSize: "20px",
                      color: "#FF9900",
                      marginRight: "10px",
                    }}
                  />
                  AWS
                </ListGroup.Item>
              )}

              {loginUser.perms?.GCP?.length > 0 && (
                <LinkContainer to="/admin/GCPAccounts">
                  <ListGroup.Item
                    action
                    className="list-group-item-secondary nav-link d-flex align-items-center"
                  >
                    <SiGooglecloud
                      style={{
                        fontSize: "20px",
                        color: "#4285F4",
                        marginRight: "10px",
                      }}
                    />
                    GCP
                  </ListGroup.Item>
                </LinkContainer>
              )}
              {loginUser.perms?.Azure?.length > 0 && (
                <LinkContainer to="/admin/AzureAccounts">
                  <ListGroup.Item
                    action
                    className="list-group-item-secondary nav-link d-flex align-items-center"
                  >
                    <FaCloud
                      style={{
                        fontSize: "20px",
                        color: "#0078D4",
                        marginRight: "10px",
                      }}
                    />
                    Azure
                  </ListGroup.Item>
                </LinkContainer>
              )}
            </div>
          </Collapse>
        </>

        {/* Manage User */}

        {!error && isLoaded && loginUser.role === "admin" && (
          <>
            <ListGroup.Item
              action
              className="list-group-item-info nav-link d-flex align-items-center"
              onClick={() => setopenManageSchedule(!openManageSchedule)}
              aria-controls="manage-user-collapse"
              aria-expanded={openManageSchedule}
            >
              <FaUser style={{ marginRight: "10px", fontSize: "20px" }} />
              Manage User
              {openManageSchedule ? (
                <FaChevronUp style={{ marginLeft: "auto" }} />
              ) : (
                <FaChevronDown style={{ marginLeft: "auto" }} />
              )}
            </ListGroup.Item>
            <Collapse in={openManageSchedule}>
              <div id="manage-user-collapse">
                <LinkContainer to="/admin/new/user">
                  <ListGroup.Item
                    action
                    className="list-group-item-secondary nav-link d-flex align-items-center"
                  >
                    <FaUserPlus
                      style={{ fontSize: "20px", marginRight: "10px" }}
                    />
                    Add User
                  </ListGroup.Item>
                </LinkContainer>
                <LinkContainer to="/admin/manage/users">
                  <ListGroup.Item
                    action
                    className="list-group-item-secondary nav-link d-flex align-items-center"
                  >
                    <FaUserFriends
                      style={{ fontSize: "20px", marginRight: "10px" }}
                    />
                    Manage Existing Users
                  </ListGroup.Item>
                </LinkContainer>
              </div>
            </Collapse>
          </>
        )}
      </ListGroup>
    </Container>
  );
}

export default SideBar;
